﻿const VALIDATORS = {
    undefined: () => false,
    boolean: () => true,
    symbol: () => true,
    number: v => !Number.isNaN(v),
    string: v => v.length,
    function: () => true,
    object: v => v !== null && Object.keys(v).length
};

export default function cleanObject(dirtyData) {
    return Object.keys(dirtyData).reduce((obj, key) => {
        const val = dirtyData[key];
        const type = typeof val;
        if (VALIDATORS[type](val)) {
            if (type === "object" && !Array.isArray(val)) {
                const innerVal = cleanObject(val);
                if (VALIDATORS.object(innerVal)) {
                    obj[key] = innerVal;
                }
            } else {
                obj[key] = val;
            }
        }
        return obj;
    }, {});
}